module.exports = __webpack_public_path__ + "static/favicon-a3610a82c62be481a9d7325b680f45b2.ico";